export const PASSKEY_COPY = {
  firmSignIn: (firmName: string) => `Sign in with ${firmName}`,
  passkeyHeading: 'Passkeys',
  passkeyBody: 'A passkey lets you confirm it is you with your fingerprint, face, device PIN, or a security key. Your device keeps the passkey; you do not type a one-time code. Passkeys are not available for VerityRx sign-in yet.',
  totpBody: 'For now, use an authenticator app code for the second sign-in check. TOTP remains available.',
} as const;
